import { useState, useMemo } from 'react'
import { applyFilters, extractFilterValues } from '../utils/filters'

const useActivityFilters = (data) => {
  const [searchText, setSearchText] = useState('')
  const [caregiverFilter, setCaregiverFilter] = useState('all')
  const [activityTypeFilter, setActivityTypeFilter] = useState('all')
  const [statusFilter, setStatusFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)

  // Extract filter values from data
  const filterValues = useMemo(() => extractFilterValues(data), [data])

  // Apply filters to data
  const filteredData = useMemo(() => {
    return applyFilters(data, {
      searchText,
      caregiverFilter,
      activityTypeFilter,
      statusFilter,
      dateRange
    })
  }, [data, searchText, caregiverFilter, activityTypeFilter, statusFilter, dateRange])

  return {
    // Filter values
    filterValues,
    // Filter states
    searchText,
    setSearchText,
    caregiverFilter,
    setCaregiverFilter,
    activityTypeFilter,
    setActivityTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange,
    // Filtered data
    filteredData
  }
}

export default useActivityFilters
